export function isNumber(value: any): value is number {
  return typeof value === 'number' && !isNaN(value);
}
export function smartFloor(num: number): number {
  const floor = Math.floor(num);
  const diff = num - floor;
  return diff > 0.99999 ? floor + 1 : floor;
}
